import React, { Component } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import AssumptionList from "./assumption/List";
import AssumptionCreate from "./assumption/Create";
import AssumptionDetail from "./assumption/Detail";

const defaultFields = {
    Subject: { visible: false, label: '', required: false },
    Compensation: { visible: false, label: '', required: false },
    DecisionRequiredBy: { visible: false, label: '', required: false },
    Details: { visible: false, label: '', required: false },
    Type: { visible: false, label: '', required: false }
}

const defaultReplyFields = {
    ReplyStatus: { visible: false, label: '', required: false },
    ReplyComment: { visible: false, label: '', required: false }
}

///ALL FIELDS ARE DECIDED WITHIN THE getFields FUNCTION
///THE getFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign fields to workflowItem
export const getFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid, globalResources, contract) => {
    const fields = { ...defaultFields };

    fields.Subject = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.SUBJECT"], required: true };
    fields.Compensation = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.COMPENSATION"], required: true };
    fields.DecisionRequiredBy =  { visible: true, label: languageFile["GENERAL.FORMS.FIELD.DECISION_REQUIRED_BY"], required: true };
    fields.Details =  { visible: true, label: languageFile["GENERAL.FORMS.FIELD.DETAILS"], required: true };

    const workflowItem = workflowsQA[wfid];
    let clauses = workflowItem.clauses;

    fields.Type.clauses = clauses;

    return fields;
}

///ALL REPLY FIELDS ARE DECIDED WITHIN THE getReplyFields FUNCTION
///THE getReplyFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign replyFields to workflowItem
export const getReplyFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid) => {
    const replyFields = { ...defaultReplyFields };

    var replyOptions = [
        { value: 'Accepted', display: languageFile["OPTIONS.STATUS.Accepted"] },
        { value: 'Not Accepted', display: languageFile["OPTIONS.STATUS.Not Accepted"] }
    ];

    replyFields.ReplyStatus = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.STATUS"], required: false };
    replyFields.ReplyStatus.replyOptions = replyOptions;
    replyFields.ReplyComment = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.COMMENTS"], required: false };
    
    return replyFields;
}

class AssumptionRouter extends Component {
  constructor(props) {
    super(props);
    this.notificationName = props.workflowItem.notificationName;

    this.notificationType = "Assumptions";
    this.documentType = "DocumentAssumptions";


    this.notificationName = props.workflowItem.notificationName;
    this.abbreviation = props.workflowItem.abbreviation;
    this.assumptionsTitle = "Contractor Assumptions";
    this.assumptionsAbbreviation = "Assumptions-";
  }
  shouldComponentUpdate() {
    return false;
  }
  render() {
    const { workflowItem } = this.props;

    return (
      <Routes caseSensitive>
        <Route path={workflowItem.paths.basePath} exact element={<Navigate replace to={workflowItem.paths.defaultPath} />} />
        <Route
          path={workflowItem.config.paths.list}
          exact
          element={
            <AssumptionList
              {...this.props}
              
              title={this.notificationName}
              abbreviation={this.abbreviation}
              notificationType={this.notificationType}
            />
          }
        />
        <Route
            path={workflowItem.config.paths.create}
            exact
            element={
                workflowItem.userFilters.mainNotice.createAllowed ? (
                  <AssumptionCreate
                      {...this.props}
                      abbreviation={this.abbreviation}
                      title={this.notificationName}
                      
                      notificationType={this.notificationType}
                    />) : (
                    <Navigate replace to={workflowItem.paths.defaultPath} />
                )
            }
        />
        <Route
          path={'/:notificationid/*'}
          element={
            <AssumptionDetail
              {...this.props}
              compAbbreviation_PM={this.compAbbreviation_PM}
              contractorAssumptionsTitle={this.contractorAssumptionsTitle}
              assumptionAbbreviation={this.assumptionAbbreviation}
              title={this.notificationName}
              abbreviation={this.abbreviation}
              
              documentType={this.documentType}
              notificationType={this.notificationType}
              ewAbbreviation_SUP={this.ewAbbreviation_SUP}
              ewAbbreviation_PM={this.ewAbbreviation_PM}
              notifyUserFilter={workflowItem.notifyUserFilter}
            />
          }
        />
      </Routes>
    );
  }
}


export default (AssumptionRouter);
